module.exports = __webpack_public_path__ + "static/img/EarPods.a1de2e32.jpg";